export default "__VITE_ASSET__HGU_RJ45__"